import clsx from "clsx";
import type { FunctionComponent, PropsWithChildren } from "react";

import type { CardVariantProps } from "~/components/Card/cardVariants.ts";
import { cardVariants } from "~/components/Card/cardVariants.ts";

type Props = PropsWithChildren & { className?: string; hasTitle?: boolean } & CardVariantProps;

const CardContent: FunctionComponent<Props> = ({
	border,
	children,
	className,
	hasTitle = false,
	height,
	padding,
	shadow,
	theme,
}) => {
	const { content } = cardVariants(
		{ border, theme, padding, shadow, hasTitle, height });
	return <div className={clsx(content(), className)}>
		{children}
	</div>;
};

export default CardContent;